module.exports = __webpack_public_path__ + "static/media/17UN-Women3.152d99ab.jpg";